import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import Arrow from './Arrow';

const ArrowIcon = props => (
    <IconFromPath {...props} Path={Arrow} />
);

export default ArrowIcon;
